import React, {Component} from 'react';
import Full from '../../containers/Full/Full.js'
import Login from '../../views/Login/Login.js'
import firebase from '../Firebase'
import { connect } from 'react-redux'
import {withRouter} from 'react-router';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Notifier from '../Notifier';
import {megaDispatch} from '../../actions/megaDispatch';
import { clearProgressItems } from '../../actions/clearProgressItems';
import LoadingBar from 'react-redux-loading-bar'
import { showLoading, hideLoading, resetLoading } from 'react-redux-loading-bar'
import Loadable from 'react-loading-overlay/lib/LoadingOverlay'
import {checkLoggedIn} from '../../actions/user'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { css } from 'glamor';
class Authenticator extends Component {

    constructor(props) {
        super(props);

        this.state = {
            filesInProgress : false,
            clientUpdatesInProgress : false
        }
    }
    componentDidMount() {
       // -- refresh data
       this.props.checkLoggedIn(this.props.clientPath.clientPath, this.props.user)
       this.props.clearProgressItems();
        if(this.props.user.isLoggedIn) {
           this.props.megaDispatch(this.props.clientPath.clientPath);
       }
    }

    _beforeUnload (e) {

        var dialogText = 'Niet alle bestanden zijn opgeslagen, weet je zeker dat je wil afsluiten?';
        e.returnValue = dialogText;
        return dialogText;

    }

    shouldComponentUpdate(nextProps) {

        let loader = nextProps.loader;

        let shouldLoad = false;

        for (var key in loader) {
            if(loader[key] === true) {
                shouldLoad = true;
            }
        }

        if(shouldLoad) {
            this.props.showLoading();
            return true;
        }else{
            this.props.hideLoading();
            this.props.resetLoading();
            return true;
        }
    }

    componentDidUpdate(prevProps) {
        
        if (this.props.location !== prevProps.location) {
          this.props.checkLoggedIn(this.props.clientPath.clientPath, this.props.user)
        }

        if ( this.props.progressFiles != prevProps.progressFiles ) {
            this._executeFileToasts();
        }

        if ( this.props.progressClients != prevProps.progressClients ) {
            this._executeClientUpdatesToasts();
        }

        if ( this.state.filesInProgress || this.state.clientUpdatesInProgress ) {
            window.onbeforeunload = this._beforeUnload;
        } else {
            window.onbeforeunload = false;
        }
    }

    _executeClientUpdatesToasts(){
        let clientUpdatesInProgress = false;
        for ( let property in this.props.progressClients ) {
            if ( this.props.progressClients.hasOwnProperty(property) ) {
                if ( !  toast.isActive(property) ) {
                    if ( this.props.progressClients[property].progress === true ) {
                        clientUpdatesInProgress = true;
                        toast( this.props.progressClients[property].message, {
                            toastId: property,
                            autoClose: false,
                            type: toast.TYPE.INFO,
                        });
                    }

                } else {
                    if (  toast.isActive(property) && this.props.progressClients[property].progress === false) {
                        toast.update(property, {
                            render: <span dangerouslySetInnerHTML={{__html: this.props.progressClients[property].message}}></span>,
                            autoClose : 5000,
                            type: toast.TYPE.INFO,
                            className: css({
                                transform: "rotateY(360deg)",
                                transition: "transform 0.6s"
                            })
                        })
                    }
                }

            }
        }
        this.setState({
            ...this.state,
            clientUpdatesInProgress
        })
    }
    _executeFileToasts(){
        let filesInProgress = false;
        for ( let property in this.props.progressFiles ) {
            if ( this.props.progressFiles.hasOwnProperty(property) ) {
                if ( !  toast.isActive(property) ) {
                    if ( this.props.progressFiles[property].progress === true ) {
                        filesInProgress = true;
                        toast( this.props.progressFiles[property].message, {
                            toastId: property,
                            autoClose: false,
                            type: toast.TYPE.INFO,
                        });
                    }

                } else {
                    if (  toast.isActive(property) && this.props.progressFiles[property].progress === false) {
                        toast.update(property, {
                            render: <span dangerouslySetInnerHTML={{__html: this.props.progressFiles[property].message}}></span>,
                            autoClose : 5000,
                            type: toast.TYPE.INFO,
                            className: css({
                                transform: "rotateY(360deg)",
                                transition: "transform 0.6s"
                            })
                        })
                    }
                }

            }
        }

        this.setState({
            ...this.state,
            filesInProgress
        })

        if ( filesInProgress ) {
            window.onbeforeunload = this._beforeUnload;
        } else {
            window.onbeforeunload = false;
        }
    }


    render() {
        return (
        	<div>
            <ToastContainer />
               <Loadable
                  active={this.props.isEditingInProgress}
                  spinner
                  text='Bezig met verwerken...'
                  zIndex={9999}
                  >
                    <LoadingBar className="loader"/>
                    <Notifier />
                	  {this.props.user.isLoggedIn ? <Full /> : <Login  />}

                </Loadable>
            </div>
            );
        }
    }

function mapStateToProps(state, ownProps) {
    return {
        user: state.UserReducer,
        clientPath: state.clientPathReducer,
        message: state.MessageReducer,
        loader: state.LoaderReducer,
        clientData: state.ClientDataReducer,
        progressFiles : state.FileReducer.files_in_progress,
        progressClients: state.ClientDataReducer.client_updates_in_progress,
        isEditingInProgress: state.LoaderReducer.EditingInProgress,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        clearProgressItems: () => dispatch(clearProgressItems()),
        megaDispatch: (url) => dispatch(megaDispatch(url)),
        showLoading: () => dispatch(showLoading()),
        hideLoading : () => dispatch(hideLoading()),
        resetLoading : () => dispatch(resetLoading()),
        checkLoggedIn : (url, userData) => dispatch(checkLoggedIn(url, userData))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Authenticator))



// WEBPACK FOOTER //
// ./src/components/Authenticator/Authenticator.js